<div class="h-dvh w-full flex flex-col">
  <mat-drawer-container class="flex-1" [autosize]="true">
    <mat-drawer [mode]="mode" [opened]="opened" class="main-drawer">
      <div class="h-full w-full">
        <div class="h-full bg-[var(--main)] flex flex-col">
          <div
            class="sticky top-0 z-10 left-0 bg-[var(--main)] flex items-center gap-4 p-4"
          >
            <div class="relative inline-block size-10">
              <img src="/assets/img/logo.png" alt="" />
            </div>
            <div class="font-bold text-xl darker-txt">Equora</div>
          </div>

          <div class="flex flex-col gap-2 px-4 pb-4">
            @for (m of lMenu; track $index) {
            <div class="flex flex-col gap-2">
              <div class="uppercase text-xs text-[var(--text-lightest)] py-2">
                {{ m.title }}
              </div>
              @for (s of m.sublinks; track $index) {
              <button
                [routerLink]="s.path"
                [routerLinkActive]="['active']"
                class="card-link text-sm"
                (click)="onNavLinkClick()"
              >
                <mat-icon>{{ s.icon }}</mat-icon>
                {{ s.title }}
              </button>
              }
            </div>
            }
          </div>
          <div class="size-12"></div>
        </div>
      </div>
    </mat-drawer>
    <mat-drawer-content
      [@routeAnimation]="prepareRoute(o)"
      class="bg-[var(--main-light)]"
    >
      <div class="size-full flex flex-col">
        <nav
          class="sticky top-0 z-10 w-full bg-[var(--main)] p-4 flex items-center justify-between border-b border-[var(--border)] gap-4"
        >
          <div class="flex items-center gap-2">
            <button class="btn btn-icon" (click)="opened = !opened">
              <mat-icon class="text-[var(--text)]">menu</mat-icon>
            </button>
            <button
              class="!hidden md:!flex btn h-[38px] w-80"
              (click)="openGlobalSearch()"
            >
              <mat-icon class="text-[var(--text)]">search</mat-icon>
              <div class="flex flex-1 flex-start text-[var(--text-lightest)]">
                Rechercher...
              </div>
              <div
                class="flex items-center rounded bg-[var(--main-light)] p-1 text-sm font-semibold text-[var(--text-lightest)]"
              >
                @if (_tools.isMac) {
                  <mat-icon>keyboard_command_key</mat-icon>
                } @else {
                  <span>CTRL</span>
                }
                + K
              </div>
            </button>
            <button
              class="flex md:hidden btn btn-icon"
              (click)="openGlobalSearch()"
            >
              <mat-icon class="text-[var(--text)]">search</mat-icon>
            </button>
          </div>

          <div class="flex items-center gap-2">
            <button class="btn btn-icon" (click)="_theme.toggleTheme()">
              <mat-icon *ngIf="_theme.isDarkTheme" class="text-[var(--text)]"
                >light_mode</mat-icon
              >
              <mat-icon *ngIf="!_theme.isDarkTheme" class="text-[var(--text)]"
                >dark_mode</mat-icon
              >
            </button>
            <button class="btn h-[38px]" [matMenuTriggerFor]="loginMenu">
              <div
                class="size-6 rounded text-sm flex items-center justify-center bg-[var(--primary)] text-[var(--primary-color)]"
              >
                {{ oLogUser.login_Nom.charAt(0)
                }}{{ oLogUser.login_Prenom.charAt(0) }}
              </div>
              <div class="hidden md:block text-[var(--text)]">
                {{ oLogUser.login_Nom }} {{ oLogUser.login_Prenom }}
              </div>
              <mat-icon class="text-[var(--text)]"
                >keyboard_arrow_down</mat-icon
              >
            </button>

            <mat-menu #loginMenu="matMenu" class="mt-4">
              <button mat-menu-item routerLink="logins">
                <mat-icon>manage_accounts</mat-icon>
                Gestion des utilisateurs
              </button>
              <button mat-menu-item (click)="logOutProcess()">
                <mat-icon class="txt-danger">logout</mat-icon>
                Se déconnecter
              </button>
            </mat-menu>
          </div>
        </nav>
        <div class="flex-1 min-h-0 overflow-auto">
          <router-outlet #o="outlet"></router-outlet>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
